<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative {{
		minClass
	}}_min_height"
	[ngClass]="{ 'c-portlet_box_specs_2': isPreroll || isCtv }"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom primary-color-bg"
	>
		<div class="o-stack__cell portlet-subheader-wrapper" *ngIf="hasData">
			<h5>
				Creatives
				<a
					href="#"
					class="datatable_download_icon"
					(click)="downloadDataInCSV($event)"
					target="_blank"
					*ngIf="totalCreatives != 0 && downloadConfiguration && downloadConfiguration.enableDownload"
				>
					<img class="downloadIcon" src="{{ downloadIcon }}" />
				</a>
			</h5>
		</div>
		<div class="o-stack__cell portlet-subheader-wrapper" *ngIf="!hasData">
			<h5>Creatives</h5>
		</div>
	</div>
	<div *ngIf="!displayCreative?.isVideoCreative && !displayCreative?.isAudioCreative">
		<div class="c-portlet__content u-pt-small" style="width: 100%; position: relative" *ngIf="hasData">
			<div class="creative-header-name {{ sectionclass }}">
				<div class="left-arrow" [ngClass]="{ 'left-arrow-social': isSocial, arrows_disabled: totalCreatives == 1 }">
					<a class="u-opacity-50p">
						<span class="next" (click)="nextArrow()" class="cursor-pointer">
							<img src="../../../../../assets/creative-assets/arrow-left-r7.svg" />
						</span>
					</a>
				</div>
				<div class="creative-card-name ellipsis" style="text-align: center; vertical-align: middle">
					<span>{{ displayCreative?.creativeName }}</span>
				</div>
				<div class="right-arrow" [ngClass]="{ 'right-arrow-social': isSocial, arrows_disabled: totalCreatives == 1 }">
					<a class="u-opacity-50p">
						<span class="prev" (click)="prevArrow()" class="cursor-pointer">
							<img src="../../../../../assets/creative-assets/arrow-right-r7.svg" />
						</span>
					</a>
				</div>
			</div>
			<div
				class="creative-carousel"
				[ngClass]="{
					'creative-carousel-snapshot-social':
						(isSocial && displayCreative?.isIframeExpired === 1 && displayCreative?.hasSnapshotImage) ||
						(displayCreative?.isIframeExpired === 0 && displayCreative?.iframeUrl !== null)
				}"
			>
				<div class="left-arrow" [ngClass]="{ 'left-arrow-social': isSocial }"></div>
				<div class="creativeImage textAlignCenter">
					<div
						*ngIf="displayCreative?.creativeThumbnail && !isSocial"
						class="creative-thumbnail"
						(click)="openModal('display-creative-v1', displayCreative)"
						[ngStyle]="{
							background: 'url(' + displayCreative?.creativeThumbnail + ') no-repeat center center / 100% 100%',
							'background-size': getCreativeSize(displayCreative.creativeThumbnail)
						}"
					></div>
					<div *ngIf="isSocial">
						<div>
							<div
								*ngIf="displayCreative.isIframeExpired === 1 && displayCreative?.hasSnapshotImage"
								class="creative-snapshot-social-div"
							>
								<div
									*ngIf="displayCreative?.snapshotImage"
									class="creative-snapshot-social"
									(click)="openModal('display-creative-v1', displayCreative)"
									[ngStyle]="{
										background: 'url(' + displayCreative?.snapshotImage + ') no-repeat center center / 100% 100%',
										'background-size': getCreativeSize(displayCreative.snapshotImage)
									}"
								></div>
							</div>
							<div
								*ngIf="displayCreative.isIframeExpired === 0 && displayCreative?.iframeUrl !== null"
								class="creative-snapshot-social-div iframe"
							>
								<div
									*ngIf="displayCreative?.iframeUrl !== null"
									class="creative-snapshot-social"
									(click)="openModal('display-creative-v1', displayCreative)"
									[ngStyle]="{
										background: 'url(' + displayCreative?.creativeThumbnail + ') no-repeat center center / 100% 100%',
										'background-size': getCreativeSize(displayCreative.creativeThumbnail)
									}"
								></div>
							</div>
							<div
								*ngIf="
									(displayCreative.isIframeExpired === 1 && !displayCreative?.hasSnapshotImage) ||
									(displayCreative.isIframeExpired === 0 && displayCreative.iframeUrl === null)
								"
								class="creative-snapshot-social-div"
							>
								<div
									*ngIf="displayCreative?.creativeThumbnail"
									class="creative-snapshot-social"
									[ngStyle]="{
										background:
											'url(../../../../../../assets/images/iframe_ad_not_available_2.png) no-repeat center center / 100% 100%',
										'background-size': getCreativeSize(displayCreative.creativeThumbnail)
									}"
								></div>
							</div>
						</div>
					</div>
				</div>
				<div></div>
			</div>
			<div class="analytics-portlet-content textAlignCenter {{ sectionclass }}_stats_position" style="width: 100%">
				<div
					*ngIf="displayCreative?.isIAB || displayCreative?.isNative"
					[ngClass]="{
						'badge-display': !displayCreative?.noPreviewImage,
						'no-preview-badge-display': displayCreative?.noPreviewImage
					}"
				>
					<p class="pills primary-color-bg" *ngIf="displayCreative?.isIAB && !displayCreative?.isNative">IAB Display</p>
					<p class="pills primary-color-bg" *ngIf="displayCreative?.isNative && !displayCreative?.isIAB">Native</p>
					<p class="pills primary-color-bg" *ngIf="displayCreative?.isIAB && displayCreative?.isNative">
						IAB Display with Native
					</p>
				</div>
				<div
					class="display-carousel-table-container"
					[ngClass]="{
						'no-social-creative':
							(isSocial && displayCreative.isIframeExpired === 1 && !displayCreative?.hasSnapshotImage) ||
							(displayCreative.isIframeExpired === 0 && displayCreative.iframeUrl === null)
					}"
				>
					<ul class="creative-stats">
						<li>
							<span class="stats primary-color">{{ displayCreative?.impressions | number }}</span>
							<span class="stats-label">Impressions</span>
						</li>
						<li *ngIf="displayCreative?.adInteractions !== null && displayCreative?.isIAB">
							<span class="stats primary-color">{{ displayCreative?.adInteractions | number }}</span>
							<span class="stats-label">Ad Interactions</span>
						</li>
						<li *ngIf="displayCreative?.adInteractionRate !== null && displayCreative?.isIAB">
							<span class="stats primary-color">{{ displayCreative?.adInteractionRate }}%</span>
							<span class="stats-label">Ad Interaction Rate</span>
						</li>
						<li>
							<span class="stats primary-color">{{ displayCreative?.clicks | number }}</span>
							<span class="stats-label">Clicks</span>
						</li>
						<li>
							<span class="stats primary-color">{{ displayCreative?.clickRate }}%</span>
							<span class="stats-label">Click Rate</span>
						</li>
					</ul>

					<div class="display-carousel-table-container engagements-grid" *ngIf="isSocial">
						<ul class="creative-stats">
							<li>
								<span class="stats primary-color">{{ displayCreative?.engagements | number }}</span>
								<span class="stats-label">Engagements</span>
							</li>
							<li>
								<span class="stats primary-color">{{ displayCreative?.likes | number }}</span>
								<span class="stats-label">Likes</span>
							</li>
							<li>
								<span class="stats primary-color">{{ displayCreative?.comments | number }}</span>
								<span class="stats-label">Comments</span>
							</li>
							<li>
								<span class="stats primary-color">{{ displayCreative?.shares | number }}</span>
								<span class="stats-label">Shares</span>
							</li>
							<li>
								<span class="stats primary-color">{{ displayCreative?.saves | number }}</span>
								<span class="stats-label">Saves</span>
							</li>
							<li>
								<span class="stats primary-color">{{ displayCreative?.reactions | number }}</span>
								<span class="stats-label">Reactions</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="!hasData">
			<img src="/assets/images/no-creative-performance-data-display.png" class="no-creative-data" width="100%" />
		</div>
	</div>
	<div *ngIf="displayCreative?.isVideoCreative || displayCreative?.isAudioCreative" style="min-height: 24vmax">
		<div class="sample" *ngIf="hasData">
			<div class="video-arrows-div" [ngClass]="{ 'video-arrows-social': isSocial }">
				<div class="arrows-div {{ sectionclass }}" [ngClass]="{ 'arrows-div-social': isSocial }">
					<span
						class="left-arrow-video"
						[ngClass]="{ 'left-arrow-social left-arrow-social-video': isSocial, arrows_disabled: totalCreatives == 1 }"
					>
						<a class="u-opacity-50p">
							<span class="next" (click)="nextArrow()" class="cursor-pointer">
								<img src="../../../../../assets/creative-assets/arrow-left-r7.svg" />
							</span>
						</a>
					</span>
					<span
						class="right-arrow-video"
						[ngClass]="{ 'right-arrow-social': isSocial, arrows_disabled: totalCreatives == 1 }"
					>
						<a class="u-opacity-50p">
							<span class="prev" (click)="prevArrow()" class="cursor-pointer">
								<img src="../../../../../assets/creative-assets/arrow-right-r7.svg" />
							</span>
						</a>
					</span>
				</div>
				<div></div>
			</div>
			<app-video-creative-r7
				[videoCreativeInputData]="displayCreative"
				[sectionclass]="sectionclass"
				[legend]="legend"
				[isSocial]="isSocial"
				[isPreroll]="isPreroll"
				[isRadio]="isRadio"
				[engagements]="displayCreative?.engagements"
				[likes]="displayCreative?.likes"
				[comments]="displayCreative?.comments"
				[saves]="displayCreative?.saves"
				[shares]="displayCreative?.shares"
				[reactions]="displayCreative?.reactions"
				[downloadconfig]="downloadconfig"
			>
			</app-video-creative-r7>
		</div>
		<div *ngIf="!hasData">
			<img src="/assets/images/no-creative-performance-data-display.png" class="no-creative-data" width="100%" />
		</div>
	</div>
	<app-modal id="display-creative-v1">
		<app-creative-ad-preview [creative]="selectedCreative" (modalClose)="closeModal('display-creative-v1')">
		</app-creative-ad-preview>
		<div class="modal-background"></div>
	</app-modal>
</div>
